// src/modules/app-views/customers/pages/Document/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  dropdownParameters,
  dropdownDivider,
  dropdownNew,
  dropdownDuplicate,
  dropdownArchive,
  dropdownRemove,
  dropdownRestore,
  dropdownRemovePermanently,
} from 'layouts/Pages/PageHeader/dropdownMenus';
import { MoreOutlined } from '@ant-design/icons';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const customersDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    // type: 'default',

    dropdownItems: [
      dropdownNew,
      // dropdownEdit,
      // dropdownReload,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,

      'divider',

      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default customersDocumentMenuButton;
